<template>
  <q-form ref="editForm">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="아차사고 기본정보" class="cardClassDetailInfo">
        <template slot="card-button">
          <q-btn-group outline>
            <!-- <c-btn 
              v-if="!disabled"
              :url="completeUrl"
              :isSubmit="isComplete"
              :param="accidentInfo"
              mappingType="PUT"
              label="등록완료" 
              icon="check"
              @beforeAction="saveAccident('COMPLETE')"
              @btnCallback="saveCallback" />
            <c-btn v-if="!disabled" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="remove" /> -->
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <c-label-text title="아차사고번호" :value="standardInfo.accidentNo"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="아차사고명" :value="standardInfo.accidentName"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="아차재해유형" :value="standardInfo.accidentKindName"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="발생가능일시" :value="standardInfo.occurrenceDate"></c-label-text>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="계획 및 담당자의견" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <c-btn
              v-if="!disabled"
              :url="updateUrl"
              :isSubmit="isSave"
              :param="accidentInfo"
              mappingType="PUT"
              label="계획/의견저장"
              icon="save"
              @beforeAction="saveAccident('SAVE')"
              @btnCallback="saveCallback" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="6"
              label="단기계획"
              name="shortPlan"
              v-model="accidentInfo.shortPlan">
            </c-textarea>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="6"
              label="중장기 계획"
              name="longPlan"
              v-model="accidentInfo.longPlan">
            </c-textarea>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="6"
              label="담당자 의견"
              name="managerOpinion"
              v-model="accidentInfo.managerOpinion">
            </c-textarea>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="tableImpr"
        title="개선 목록"
        :columns="gridImpr.columns"
        :data="accidentInfo.accidentImproveModelList"
        :gridHeight="gridImpr.height"
        :merge="gridImpr.merge"
        selection="multiple"
        rowKey="causesNo"
        :isExcelDown="false"
        :usePaging="false"
        :filtering="false"
        :columnSetting="false"
        :editable="editable && !disabled"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="add" />
            <c-btn
              v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0"
              :url="updateCauseUrl"
              :isSubmit="isSave2"
              :param="accidentInfo.accidentImproveModelList"
              mappingType="PUT"
              label="저장"
              icon="save"
              @beforeAction="saveAccident2"
              @btnCallback="saveCallback" 
            />
            <c-btn v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeImpr" />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <div v-if="props.row.editFlag!=='C'">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'near-cause-prevention',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
      }),
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
      standardInfo: {
        accidentNo: '',
        accidentName: '',
        accidentKindName: '',
        accidentGradeName: '',
        occurrenceDate: '',
        occurrenceDeptName: '',
        occurrenceModeLargeName: '',
        occurrenceModeSmallName: '',
        accidentStatusCd: '',
      },
      accidentInfo: {
        shortPlan: '',
        longPlan: '',
        managerOpinion: '',
        accidentStautsCd: '',

        accidentImproveModelList: [],
      },
      gridImpr: {
        columns: [
          {
            required: true,
            name: 'causeTypeCd',
            field: 'causeTypeCd',
            label: '원인구분',
            align: 'center',
            style: 'width:10%',
            type: 'select',
            comboItems: [
              { code: 'ICDC000001', codeName: '기술적' },
              { code: 'ICDC000002', codeName: '교육적' },
              { code: 'ICDC000003', codeName: '관리적' },
            ],
            sortable: false,
          },
          {
            required: true,
            name: 'accidentCause',
            field: 'accidentCause',
            label: '사고원인',
            align: 'left',
            type: 'text',
            style: 'width:30%',
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:20%',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improvingMeasures',
                field: 'improvingMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:40%',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        
        data: [],
        height: '400px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        popupParam: {},
        closeCallback: null,
      },
      colorItems: [],
      requestImprRow: null,
      imprData: null,
      completeType: 'PUT',
      completeUrl: 'transactionConfig.sop.iim.accident.near.prevention.complete.url',
      deleteUrl: '',
      searchUrl: '',
      isComplete: false,
      isSave: false,
      isSave2: false,
      updateUrl: 'transactionConfig.sop.iim.accident.near.prevention.update.url',
      updateCauseUrl: 'transactionConfig.sop.iim.accident.near.prevention.update.cause.url',
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.accidentInfo.accidentStatusCd) && this.accidentInfo.accidentStatusCd !== 'ISNC000001'
    }
  },
  watch: {
    'count'() {
      this.getStdInfo();
      this.getDetail();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      this.getUrl = selectConfig.sop.iim.accident.near.get.url;
      this.getInfoUrl = selectConfig.sop.iim.accident.near.prevention.get.url;
      this.updateUrl = transactionConfig.sop.iim.accident.near.prevention.update.url
      this.updateCauseUrl = transactionConfig.sop.iim.accident.near.prevention.update.cause.url;
      this.deleteUrl = transactionConfig.sop.iim.accident.near.prevention.delete.url
      this.completeUrl = transactionConfig.sop.iim.accident.near.prevention.complete.url

      this.getStdInfo();
      this.getDetail();
    },
    getStdInfo() {
      if (this.popupParam.iimAccidentId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.standardInfo = _result.data;
          this.updateMode = true;
        },);
      }
    },
    getDetail() {
      if (this.popupParam.iimAccidentId) {
        this.$http.url = this.$format(this.getInfoUrl, this.popupParam.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.accidentInfo = _result.data;
          this.updateMode = true;
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.accidentCause;
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.causesNo,
          ibmTaskTypeCd: 'ITT0000045',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.causesNo,
          ibmTaskTypeCd: 'ITT0000045',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.getDetail();
        this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
        let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
        if (splitId && splitId.length > 0) {
          let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
          splitStep[idIndex] = result.col1.ibmStepName;
          this.requestImprRow.ibmStepNames = splitStep.toString();
        }
        this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
      }
      this.getDetail();
    },
    saveAccident(type) {
      if (type === 'COMPLETE') {
        this.$refs['editForm'].validate().then(_result => {
          if (_result) { 
            let isConti = true;
            let checkItem = ['causeTypeCd', 'accidentCause' ]
            this.$_.forEach(this.accidentInfo.accidentImproveModelList, item => {
              this.$_.forEach(checkItem, check => {
                if (!item[check]) {
                  isConti = false;
                  return false;
                }
              })
            });
            if (!isConti) {
              window.getApp.$emit('ALERT', {
                title: '안내', // 안내
                message: '필수 입력값을 입력해 주세요. [원인구분, 사고원인]',
                type: 'warning', // success / info / warning / error
              });
            } else {
              window.getApp.$emit('CONFIRM', {
                title: '확인',
                message: '저장하시겠습니까?',
                // TODO : 필요시 추가하세요.
                type: 'info', // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.accidentInfo.regUserId = this.$store.getters.user.userId
                  this.accidentInfo.chgUserId = this.$store.getters.user.userId
                  this.isComplete = !this.isComplete;
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            }
          }else {
            window.getApp.$emit('APP_VALID_ERROR');
          }
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.accidentInfo.regUserId = this.$store.getters.user.userId
            this.accidentInfo.chgUserId = this.$store.getters.user.userId
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveAccident2() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          let isConti = true;
          let checkItem = ['causeTypeCd', 'accidentCause' ]
          this.$_.forEach(this.accidentInfo.accidentImproveModelList, item => {
            this.$_.forEach(checkItem, check => {
              if (!item[check]) {
                isConti = false;
                return false;
              }
            })
          });
          if (!isConti) {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '필수 입력값을 입력해 주세요. [원인구분, 사고원인]',
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '저장하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.accidentInfo.regUserId = this.$store.getters.user.userId
                this.accidentInfo.chgUserId = this.$store.getters.user.userId
                this.isSave2 = !this.isSave2;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completeAccident() {
       this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          let isConti = true;
          let checkItem = ['causeTypeCd', 'accidentCause']
          this.$_.forEach(this.accidentInfo.accidentImproveModelList, item => {
            this.$_.forEach(checkItem, check => {
              if (!item[check]) {
                isConti = false;
                return false;
              }
            })
          });
          if (!isConti) {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '필수 입력값을 입력해 주세요. [원인구분, 사고원인]',
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '등록완료 하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.accidentInfo.regUserId = this.$store.getters.user.userId
                this.accidentInfo.chgUserId = this.$store.getters.user.userId
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(transactionConfig.sop.iim.accident.near.delete.url, this.accidentInfo.iimAccidentId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup', 'REMOVE');  
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    add() {
      this.accidentInfo.accidentImproveModelList.splice(0, 0, {
        iimAccidentId: this.popupParam.iimAccidentId,
        causesNo: uid(),
        causeTypeCd: null,
        accidentCause: '',
        improvingMeasures: '',
        sopImprovementIds: '', 
        ibmStepNames: '', 
        editFlag: 'C',
      })
    },
    removeImpr() {
      let selectData = this.$refs['tableImpr'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$refs['tableImpr'].$refs['compo-table'].clearSelection();
              this.getDetail();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
